import React from "react";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import Media from "../api/Media";
import imgExcel from "../img/icons/download_excel.png";

export const ExportToExcel = ({ fileName, excel }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = () => {
    const reportExcel = excel;
    const ws = utils.json_to_sheet(reportExcel);
    // Рассчитываем ширину столбцов
    if (reportExcel.length > 0) {
      const columnWidths = {};

      // Обрабатываем заголовки
      Object.keys(reportExcel[0]).forEach((key) => {
        columnWidths[key] = key.length; // Начинаем с длины заголовка
      });

      // Обрабатываем данные
      reportExcel.forEach((row) => {
        Object.keys(row).forEach((key) => {
          const value = String(row[key] || ""); // Преобразуем значение в строку
          if (value.length > columnWidths[key]) {
            columnWidths[key] = value.length;
          }
        });
      });

      // Преобразуем в массив и устанавливаем ширину
      ws["!cols"] = Object.values(columnWidths).map((width) => ({
        wch: width + 4,
      }));
    }
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    saveAs(data, fileName + fileExtension);
  };

  if (!Media.mobile) {
    return (
      <button className="exportToExcel" onClick={exportToCSV}>
        Экспорт в Excel
      </button>
    );
  } else {
    return (
      <img
        className="exportToExcelImg"
        onClick={exportToCSV}
        src={imgExcel}
        alt="excel"
      />
    );
  }
};
